"use strict";

const svgApprovedIcon = `
<svg viewBox="0 0 150 150">
  <g fill="#be2b31">
    <path d="M76.4,0c5,0.8,10.1,1.3,15,2.4c11,2.3,21.2,7.2,29.9,14.2l-8,7.8c-5.4-2.7-10.6-5.9-16.2-8 C59.2,1.9,17.5,27.2,12.5,67.5c-4.3,34.4,19.3,65.1,53.9,70.5c32.7,5,64.9-18.3,70.6-51.5c1.1-6.2,0.3-12.7,0.6-19 c0.1-1.9,0.7-3.7,1.7-5.2c2-2.7,4.5-5,7.5-8.3l3.2,13.4l0,15.7c-0.3,0.8-0.6,1.6-0.8,2.4c-5.2,30.7-22.6,51-51.8,61.2 c-3.8,1.3-7.8,2.1-11.8,3.2l-21,0c-0.6-0.3-1.3-0.6-2-0.8c-31.7-6.5-51.8-25.4-60.4-56.5C1.3,89.4,0.7,86,0,82.6l0-14.3 c0.3-0.8,0.6-1.6,0.8-2.4C4.5,35,28,9,58.4,2.4c4.9-1.1,10-1.6,15-2.4L76.4,0z"/>
    <path d="M137.6,24.8l8.3,7.8l-73.1,73.3L42.2,72l8.7-8l22.7,25L137.6,24.8z"/>
  </g>
</svg>
`;

const svgOnHoldIcon = `
<svg viewBox="0 0 200 200">
  <g fill="#be2b31">
    <path d="M0,100.6c7.1-142,210.1-129.8,200,12C177.5,234,7.8,223.5,0,100.6z M16.2,99.2 c4.1,114.3,170.1,106.6,168.4-2.6C181.8-8.7,19.1-13.4,16.2,99.2z"/>
    <path d="M144.8,98v15H86.1V40.1H101c0.6,16.9,0.1,33.6,0.3,50.5c0,7.1,0,7.1,6.9,7.1C120.4,97.9,132.5,97.4,144.8,98z"/>
  </g>
</svg>
`;

const svgDeniedIcon = `
<svg viewBox="0 0 200 200">
  <g fill="#be2b31">
    <path d="M0,110V91c0.5-1.2,0.8-2.5,1.1-3.8c5.2-40.8,36.2-75.1,76.4-84C84.2,1.7,91.2,1,98,0h4 c1.4,0.4,2.8,0.7,4.3,0.9c42.2,2.5,78.2,31.5,89.7,72.2c1.7,5.9,2.7,11.9,4.1,17.9v19c-0.4,1.1-0.8,2.2-1,3.3 c-5.9,42.6-35.9,75.2-77.9,84.8c-2.4,0.5-4.7,1.3-7,2H86c-0.7-0.4-1.4-0.8-2.1-1c-41.3-8.1-68-32.5-80.3-72.6 C2,121.1,1.2,115.5,0,110z M45,164c23.1,19.1,49.5,25.7,78.5,17c32.8-9.9,52.9-32.7,59.2-66.3c4.9-26-2.4-49.1-19.3-69.1L45,164z M151,33.5c-25.3-17.9-52.6-22.8-81.3-11.4C37.5,35,19.4,59.7,16.1,94.1c-2,21.2,4.1,40.4,17.2,57.1L151,33.5z"/>
  </g>
</svg>
`;

export default {
	"checkout": {
		"loanApplication": {
			"SIGNED": {
				"message": "Vi har modtaget din underskrift af låneaftalen.<br /><br />Lånebeløbet afregner vi direkte til webshoppen, som er informeret om din finansiering.<br /><br /><span class='sparxpres-attention'>Husk at færdiggøre ordren.</span>",
				"svgIcon": svgApprovedIcon,
			},
			"NOTSIGNED": {
				"message": "Finansieringen er først godkendt, når du har underskrevet låneaftalen.<br />Vi har sendt en e-mail, hvori der er links til underskriftrummet, som kan benyttes til at underskrive låneaftalen.<br /><br /><span class='sparxpres-attention'>Husk at færdiggøre ordren.</span>",
				"svgIcon": svgApprovedIcon,
			},
			"REFERRER": {
				"message": "Tak for den fremsendte låneansøgning.<br /><br />Du modtager i løbet af kort tid en ansøgningsbekræftelse på e-mail.<br />Vi behandler din ansøgning hurtigst muligt og normalt indenfor 24 timer. Når ansøgningen er behandlet modtager du en e-mail med det endelige svar.<br /><br /><span class='sparxpres-attention'>Husk at færdiggøre ordren.</span>",
				"svgIcon": svgOnHoldIcon,
			},
			"DECLINE": {
				"message": "Tak for den fremsendte låneansøgning.<br /><br />Vi ser os desværre ikke i stand til at imødekomme ansøgningen.<br /><br /><span class='sparxpres-attention'>Vælg venligst en anden betalingsform.</span>",
				"svgIcon": svgDeniedIcon,
			},
			"XPRESPAY_CAPTURED": {
				"message": "Din betaling med XpresPay er gennemført.<br /><br />Vi afregner beløbet direkte til webshoppen, som er informeret om din betaling.<br /><br /><span class='sparxpres-attention'>Husk at færdiggøre ordren.</span>",
				"svgIcon": svgApprovedIcon,
			}
		},
		"amount": {
			"tooLow": "Din ordretotal er ikke understøttet af Sparxpres. Derfor bliver du desværre nødt til at vælge en anden betalingsmetode for at fortsætte.",
			"tooHigh": "Din ordretotal er ikke understøttet af Sparxpres. Derfor bliver du desværre nødt til at vælge en anden betalingsmetode for at fortsætte.",
			"invalid": "Hverken Sparxpres delbetaling eller XpresPay er muligt på dette ordrebeløb, vælg venligst en anden betalingsmetode for at forsætte."
		}
	},
	"product-checkout": {
		"loanApplication": {
			"SIGNED": {
				"message": "Vi har modtaget din underskrift af låneaftalen.<br /><br />Lånebeløbet afregner vi direkte til webshoppen, som er informeret om din finansiering.",
				"svgIcon": svgApprovedIcon,
			},
			"NOTSIGNED": {
				"message": "Finansieringen er først godkendt, når du har underskrevet låneaftalen.<br />Vi har sendt en e-mail, hvori der er links til underskriftrummet, som kan benyttes til at underskrive låneaftalen.",
				"svgIcon": svgApprovedIcon,
			},
			"REFERRER": {
				"message": "Tak for den fremsendte låneansøgning.<br /><br />Du modtager i løbet af kort tid en ansøgningsbekræftelse på e-mail.<br />Vi behandler din ansøgning hurtigst muligt og normalt indenfor 24 timer. Når ansøgningen er behandlet modtager du en e-mail med det endelige svar.",
				"svgIcon": svgOnHoldIcon,
			},
			"DECLINE": {
				"message": "Tak for den fremsendte låneansøgning.<br /><br />Vi ser os desværre ikke i stand til at imødekomme ansøgningen.",
				"svgIcon": svgDeniedIcon,
			},
			"XPRESPAY_CAPTURED": {
				"message": "Din betaling med XpresPay er gennemført.<br /><br />Vi afregner beløbet direkte til webshoppen, som er informeret om din betaling.<br /><br /><span class='sparxpres-attention'>Husk at færdiggøre ordren.</span>",
				"svgIcon": svgApprovedIcon,
			}
		},
		"amount": {
			"tooLow": "Din ordretotal er ikke understøttet af Sparxpres. Derfor bliver du desværre nødt til at vælge en anden betalingsmetode for at fortsætte.",
			"tooHigh": "Din ordretotal er ikke understøttet af Sparxpres. Derfor bliver du desværre nødt til at vælge en anden betalingsmetode for at fortsætte.",
			"invalid": "Hverken Sparxpres delbetaling eller XpresPay er muligt på dette ordrebeløb, vælg venligst en anden betalingsmetode for at forsætte."
		}
	},
	"product": {}
}
